export const AVAILABLE_CROPS = ['corn', 'wheat', 'soy', 'barley'] as const;
export const MIN_ENVIRONMENT = 1000;
export const MAX_ENVIRONMENT = 15000;

export type CropMonitoringFormType = {
    id: number | undefined;
    plantingDate: string | undefined;
    product: number | undefined | string;
    technology: number | undefined;
    environment: number | undefined;
    fieldId: number | undefined;
    crop: (typeof AVAILABLE_CROPS)[number] | '';
    previousCrop: (typeof AVAILABLE_CROPS)[number] | '' | 'none' | 'other';
};

export type FieldOption = {
    label: string;
    value: number;
};
